import * as React from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import * as routes from "../../constants/routes";
import { compose } from "recompose";
import { Container, Header } from "semantic-ui-react";
import { Navigation } from "src/components/Navigation";
import { ISessionState } from "src/reducers/session";
import { withAuthorization } from "../../components/Session/withAuthorization";
import ManageUsersTable from "./ManageUsersTable";

interface IManageUsersComponent {
  session: ISessionState;
  history: any;
  match: any;
  location: any;
}

const ManageUsersComponent = ({
  session,
  history,
  location,
  match,
}: IManageUsersComponent) => {
  if (session.roles) {
    return (
      <React.Fragment>
        {!session.roles.admin && !session.roles.owner && (
          <Redirect to={routes.ERROR} />
        )}
        <Navigation />
        <Container className="main-container">
          <Header as="h2" className="page-title">
            ManageUsers
          </Header>
          <ManageUsersTable
            authUser={session.authUser}
            orgId={session.orgId}
            orgConfig={session.orgConfig}
            location={location}
            history={history}
          />
        </Container>
      </React.Fragment>
    );
  } else {
    return null;
  }
};

const mapStateToProps = (state: any) => ({
  session: state.sessionState,
});

const authCondition = (authUser: any) => !!authUser;

const ManageUsers = compose(
  withAuthorization(authCondition),
  connect(mapStateToProps)
)(withRouter(ManageUsersComponent));

export default ManageUsers;



// WEBPACK FOOTER //
// ./src/containers/ManageUsers/index.tsx